import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { AlertCircleIcon, TimerIcon, FlameIcon } from 'lucide-react';
export function UrgencyOfferSection() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('urgency_end_time');
    if (saved) {
      const diff = Math.max(0, Math.floor((Number(saved) - Date.now()) / 1000));
      return diff > 0 ? diff : 24 * 60 * 60;
    }
    const endTime = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('urgency_end_time', String(endTime));
    return 24 * 60 * 60;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-12 md:py-16 px-4 border-y-4 border-gray-900 relative overflow-hidden pt-[25px] pb-[25px] mt-[0px] mb-[0px]" data-id="element-385">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-900/20 blur-[100px] pointer-events-none rounded-full" data-id="element-386"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-387">
        <div className="text-center mb-10" data-id="element-388">
          <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-500 px-6 py-2 rounded-full font-black text-sm md:text-base uppercase tracking-widest border border-red-500/50 mb-6" data-id="element-389">
            Oferta por tiempo limitado
          </div>

          <h2 className="md:text-5xl font-black text-white mb-6 text-[20px]" data-id="element-390">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
        </div>

        {/* Neon Countdown Timer */}
        <div className="flex justify-center mb-10" data-id="element-391">
          <div className="bg-gray-900 border-2 border-red-600 rounded-3xl p-6 md:p-10 animate-neon-red text-center min-w-[300px] md:min-w-[400px]" data-id="element-392">
            <div className="flex items-center justify-center gap-3 mb-4 text-red-500" data-id="element-393">
              <TimerIcon className="w-8 h-8" data-id="element-394" />
              <span className="text-xl font-bold uppercase tracking-widest" data-id="element-395">
                Tiempo Restante
              </span>
            </div>
            <div className="text-6xl md:text-8xl font-black text-red-500 tracking-wider font-mono animate-pulse-fast drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-396">
              {pad(hours)}:{pad(minutes)}:{pad(seconds)}
            </div>
          </div>
        </div>

        {/* Scarcity Bar */}
        <div className="bg-gray-900/80 rounded-2xl p-6 md:p-8 border border-gray-800 pt-[20px] pb-[20px] mt-[20px] mb-[20px]" data-id="element-397">
          <div className="flex justify-between items-end mb-3" data-id="element-398">
            <div className="flex items-center gap-2 text-red-500 font-bold text-lg md:text-xl uppercase" data-id="element-399">
              ¡SOLO QUEDAN 10 CUPOS!
            </div>
            <span className="text-gray-400 font-medium" data-id="element-400">75% Lleno</span>
          </div>
          <div className="w-full h-6 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-401">
            <motion.div initial={{
            width: '0%'
          }} animate={{
            width: '65%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-red-700 to-red-500 relative" data-id="element-402">
              <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.2)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.2)_50%,rgba(255,255,255,0.2)_75%,transparent_75%,transparent)] bg-[length:20px_20px] animate-[slide_1s_linear_infinite]" data-id="element-403"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}